import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import QRCode from 'react-qr-code'
import { Download } from '@mui/icons-material'
import { useReaderContext } from '../../../Contexts/Modules/ReaderModule/ReaderModule'
import { LoadingButton } from '@mui/lab'

function ModalLoad() {
  const [batch, setBatch] = useState('')
  const [batchFeeback, setBatchFeedback] = useState('')
  const { mutateBarcodes, setOpenLoad, openLoad, setBarcodes, setSourceBatch } =
    useReaderContext()
  // clear on load
  useEffect(() => {
    setBatch('')
  }, [openLoad])
  const validPattern = useMemo(
    () =>
      /^(((RACK|[A-Z]+)*[0-9]+) [0-9]{4}\/[0-9]{2}\/[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}\n?)+$/,
    [],
  )

  useEffect(() => {
    setBatchFeedback(
      batch
        .split('\n')
        .map((e) => {
          if (e.length === 0) return ''
          else return validPattern.test(e) ? 'Valid' : 'Invalid'
        })
        .join('\n'),
    )
  }, [batch, validPattern])

  return (
    <>
      <Button
        variant={'outlined'}
        startIcon={<Download />}
        onClick={() => setOpenLoad(true)}
      >
        Load
      </Button>
      <Dialog open={openLoad}>
        <DialogTitle>Load barcodes from memory</DialogTitle>
        <DialogContent>
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', pt: 1 / 2 }}
          >
            <Box
              sx={{
                mr: 2,
                display: 'flex',
                maxWidth: 500,
              }}
            >
              <TextField
                autoFocus
                sx={{ minWidth: 300 }}
                value={batch}
                onChange={(e) => {
                  setBatch(e.target.value)
                }}
                fullWidth
                multiline
                minRows={10}
                error={!!batch && !batch.match(validPattern)}
              />
              <TextField
                sx={{ pl: 1 / 2 }}
                autoFocus
                disabled
                value={batchFeeback}
                fullWidth
                multiline
                minRows={10}
              />
            </Box>
            <Box
              sx={{
                maxWidth: 100,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <QRCode
                size={100}
                style={{ height: '100px', width: '100px' }}
                value={'%%SpecCode16'}
                viewBox={`0 0 256 256`}
              />
              <Button
                variant={'outlined'}
                color={'error'}
                disabled={validPattern.test(batch)}
                onClick={() => {
                  setBatch((e) => {
                    let newBatch = ''
                    e.split('\n').forEach((e) => {
                      if (validPattern.test(e)) {
                        newBatch += e + '\n'
                      }
                    })
                    return newBatch
                  })
                }}
              >
                Remove Invalid Rows
              </Button>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          {batch ?
            <>
              <Button
                onClick={() => {
                  setOpenLoad(false)
                  setBatch('')
                }}
                disabled={mutateBarcodes.isLoading}
                color="error"
              >
                Cancel
              </Button>
              <LoadingButton
                onClick={() => {
                  setBarcodes((b: any) => {
                    const newB = b
                    batch.split('\n').forEach((entry: string) => {
                      if (entry) {
                        newB[entry.slice(0, entry.length - 20)] =
                          entry.slice(-19)
                      }
                    })
                    return { ...newB }
                  })
                  setSourceBatch(true)
                }}
                disabled={!batch.match(validPattern)}
                color="success"
                loading={mutateBarcodes.isLoading}
              >
                Save
              </LoadingButton>
            </>
          : <Button
              onClick={() => {
                setOpenLoad(false)
              }}
            >
              Close
            </Button>
          }
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ModalLoad
